/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarDaySubSection } from './calendar-day-sub-section';
import { Time } from '../../types';

export class CalendarDaySection {
  get length(): number {
    return this.zones.length;
  }

  public hour: number;
  public time: string;
  public zones: CalendarDaySubSection[];

  constructor(hour: number) {
    this.hour = hour;
    this.time = `${hour}`.padStart(2, '0');
  }

  public generateSubZones(start: Time, end: Time, sectionsByHour: number) {
    this.zones = [];
    const first = this.hour === start.hours ? start.minutes : 0;
    this.zones.push(new CalendarDaySubSection(this.hour, first));
    const step = Math.floor(60 / sectionsByHour);
    const max = this.hour === end.hours ? end.minutes : 60;
    for (let index = first; index + step < max; index += step) {
      this.zones.push(new CalendarDaySubSection(this.hour, index + step));
    }
  }

  select(start?: Time, end?: Time): CalendarDaySubSection[] {
    let zones;
    if (start && end) {
      if (start.hours * 60 + start.minutes <= end.hours * 60 + end.minutes) {
        zones = this.zones.filter((z) => this.isBetween(z, start, end));
      } else {
        zones = this.zones.filter((z) => this.isBetween(z, end, start));
      }
    } else if (start) {
      if (this.hour === start.hours) {
        const index = this.zones.findIndex((z) => z.minutes >= start.minutes);
        if (index >= 0) {
          zones = this.zones.slice(index);
        }
      } else if (this.hour > start.hours) {
        zones = this.zones;
      }
    } else {
      zones = this.zones;
    }
    if (zones) {
      for (const sub of zones) {
        sub.select(true);
      }
    }
    return zones;
  }

  private isBetween(
    section: CalendarDaySubSection,
    start: Time,
    end: Time
  ): boolean {
    if (this.hour > start.hours && this.hour < end.hours) {
      return true;
    } else if (this.hour === start.hours) {
      return (
        section.minutes >= start.minutes &&
        (this.hour < end.hours || section.minutes <= end.minutes)
      );
    } else if (this.hour === end.hours) {
      return section.minutes <= end.minutes;
    }
    return undefined;
  }
}
